/**
 * The below file contains the constants used in the UrbanFlood Non Inmates Registration
 * @author: vishal.mishra@velsof.com
 * @date :06-02-2025
 */

export const GET_ALL_URBANFLOOD_NON_INMATES_REGISTRATION =
  "GET_ALL_URBANFLOOD_NON_INMATES_REGISTRATION";
export const SET_ALL_URBANFLOOD_NON_INMATES_REGISTRATION =
  "SET_ALL_URBANFLOOD_NON_INMATES_REGISTRATION";

export const REPORT_DATE_PARAM = "reportDate";
export const STATUS_PARAM = "status";
export const GET_ALL_CREATE_URBANFLOOD_NON_INMATES_REGISTRATION =
  "GET_ALL_CREATE_URBANFLOOD_NON_INMATES_REGISTRATION";
export const SET_ALL_CREATE_URBANFLOOD_NON_INMATES_REGISTRATION =
  "SET_ALL_CREATE_URBANFLOOD_NON_INMATES_REGISTRATION";

export const GET_ALL_UPDATE_URBANFLOOD_NON_INMATES_REGISTRATION =
  "GET_ALL_UPDATE_URBANFLOOD_NON_INMATES_REGISTRATION";
export const SET_ALL_UPDATE_URBANFLOOD_NON_INMATES_REGISTRATION =
  "SET_ALL_UPDATE_URBANFLOOD_NON_INMATES_REGISTRATION";

export const SET_URBANFLOOD_NON_INMATES_REGISTRATION =
  "SET_URBANFLOOD_NON_INMATES_REGISTRATION";

/**Constants for relief camp Import page */
export const NON_CAMP_INMATES_REGISTRATION_IMPORT =
  "URBANFLOOD_NON_CAMP_INMATES_REGISTRATION_IMPORT";
export const NON_CAMP_INMATES_REGISTRATION_IMPORT_EXCEL =
  "URBANFLOOD_NON_CAMP_INMATES_REGISTRATION_IMPORT_EXCEL";
/**Constants for relief camp Import page */

/**Constants for camp inmates registration export */
export const GET_EXPORT_NON_CAMP_INMATES_DATA =
  "URBANFLOOD_GET_EXPORT_NON_CAMP_INMATES_DATA";
export const SET_EXPORT_NON_CAMP_INMATES_DATA =
  "URBANFLOOD_SET_EXPORT_NON_CAMP_INMATES_DATA";
